import { createSimpleAction, createTypeAction } from "../utils/actionUtils"

export const DELETE_TERMIN = 'DELETE_TERMIN'
export const deleteTerminAction = createSimpleAction(DELETE_TERMIN, 'terminId')

export const IMPORT_ICAL_TERMINE = 'IMPORT_ICAL_TERMINE'
export const importICalTermineAction = createSimpleAction(IMPORT_ICAL_TERMINE, 'icalTermine')
export const IMPORT_ICAL_TERMINE_SUCCESS = 'IMPORT_ICAL_TERMINE_SUCCESS'
export const importICalTermineSuccessAction = createSimpleAction(IMPORT_ICAL_TERMINE_SUCCESS, 'icalImportCounters')
export const IMPORT_ICAL_TERMINE_FAILURE = 'IMPORT_ICAL_TERMINE_FAILURE'
export const importICalTermineFailureAction = createSimpleAction(IMPORT_ICAL_TERMINE_FAILURE, 'icalImportCounters')
export const IMPORT_ICAL_RESET_REQUEST = 'IMPORT_ICAL_RESET_REQUEST'
export const importICalResetRequestAction = createTypeAction(IMPORT_ICAL_RESET_REQUEST)
export const SKIP_IMPORT_ICAL_TERMINE = 'SKIP_IMPORT_ICAL_TERMINE'
export const skipImportIcalTermine = createSimpleAction(SKIP_IMPORT_ICAL_TERMINE, 'icalImportCounters')
